<template>
    <div
        v-if="selectedOrderStatusConfig.showShippingSummary || selectedOrderStatusConfig.showOrderSummary"
        class="os-overview"
        :class="{ 'os-overview--dcc': showDccSummary }"
    >
        <div
            v-if="selectedOrderStatusConfig.showShippingSummary"
            class="os-overview__container os-overview__container--shipping-summary"
        >
            <ShippingSummary :status="this.status" />
        </div>
        <div
            v-if="showDccSummary"
            class="os-overview__container os-overview__container--dcc-summary"
        >
            <DccSummary />
        </div>
        <div
            v-if="selectedOrderStatusConfig.showOrderSummary"
            class="os-overview__container os-overview__container--order-summary"
        >
            <OrderSummary />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import ShippingSummary from './components/ShippingSummary';
    import OrderSummary from './components/OrderSummary';
    import DccSummary from './components/DccSummary.vue';
    import OrderStatusHeaderConfig from '@/models/OrderStatusHeaderConfig';

    export default {
        components: {
            ShippingSummary,
            OrderSummary,
            DccSummary,
        },

        data() {
            return {
                selectedOrderStatusConfig: {},
            };
        },

        props: {
            status: {
                type: String,
                required: true,
            },
        },

        methods: {
            setStatusConfig() {
                this.selectedOrderStatusConfig = OrderStatusHeaderConfig[this.status];
            },
        },

        computed: {
            ...mapGetters({
                dcc: 'orderStatus/getDcc'
            }),

            /**
             * A flag do status decide se esse pedido *pode* ter seção de conversão; a
             * presença do dado decide se ele *de fato* teve adesão ao DCC. A maioria dos
             * pedidos pagos não tem, e nesse caso a tela fica igual à de hoje.
             */
            showDccSummary() {
                return !!(this.selectedOrderStatusConfig.showDccSummary && this.dcc);
            },
        },

        created() {
            this.setStatusConfig();
        },
    };
</script>

<style lang="scss" scoped>
    .os-overview {
        display: flex;
        flex-direction: column;
        align-self: center;
        flex: 1 0 auto;
        width: 100%;
        padding-top: 24px;
        border-top: 1px solid #B8C1CC;

        @media screen and (min-width: 1025px) {
            flex-direction: row;
            justify-content: space-between;
            padding-top: 32px;
        }

        &__container {

            @media screen and (min-width: 1025px) {
                width: calc(50% - 44px);
            }

            &--shipping-summary {
            }
            &--order-summary {
            }
            &--dcc-summary {
                margin-bottom: 24px;
            }
        }

        // Só no cenário de DCC o desktop empilha na vertical, como o mobile já faz. A
        // largura fica limitada em OrderStatus.vue: os-header é irmão deste componente, fora
        // do alcance do CSS scoped daqui. Fora do cenário de DCC a diagramação de hoje (duas
        // colunas lado a lado, largura cheia) permanece igual.
        &--dcc {
            @media screen and (min-width: 1025px) {
                flex-direction: column;
            }

            .os-overview__container {
                @media screen and (min-width: 1025px) {
                    width: 100%;
                }
            }
        }
    }
</style>
